import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import monthlyCloseoutService from 'src/services/apiServices/monthlyCloseOut/monthlyCloseoutService';

const useIsDateInClosedPeriod = (date: any) => {
  const [isInClosedPeriod, setIsInClosedPeriod] = useState(false);
  const [loading, setLoading] = useState(false);
  const prevDateRef = useRef<string>('');

  useEffect(() => {
    if (!date) {
      setIsInClosedPeriod(false);
      return;
    }

    const formattedDate = moment(date).format('YYYY-MM-DD');

    if (prevDateRef.current === formattedDate) return;
    prevDateRef.current = formattedDate;

    let cancelled = false;
    const checkClosedPeriod = async () => {
      setLoading(true);
      try {
        const today = moment().format('YYYY-MM-DD');
        const response = await monthlyCloseoutService.getMonthlyCloseOut({
          param: {
            currentDate: today,
            division: 'MONTHLY',
          },
        });

        if (cancelled) return;

        const periods = response?.data?.data;
        if (Array.isArray(periods)) {
          // Find the period whose date range contains the selected date
          const targetMonth = formattedDate.substring(0, 7); // "YYYY-MM"
          const matchingPeriod = periods.find((period: any) => {
            const periodMonth = period?.range?.startDate?.substring(0, 7);
            return periodMonth === targetMonth;
          });
          setIsInClosedPeriod(matchingPeriod?.status === 'CLOSED_AND_SIGNED');
        } else {
          setIsInClosedPeriod(false);
        }
      } catch {
        if (!cancelled) setIsInClosedPeriod(false);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    checkClosedPeriod();
    return () => {
      cancelled = true;
    };
  }, [date]);

  return { isInClosedPeriod, loading };
};

export default useIsDateInClosedPeriod;
